import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/Gallery.css'; // Import Gallery CSS for hero section
import '../../styles/Contact.css'; // Import Contact CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import ContactUs from './ContactUs'; // Ensure the path is correct


const HeroContactUs = () => {
  return (
    <>
     <Helmet>
          <title>RCS Logistics Philippines - Contact Us</title>
          <meta name="description" content="Partner with RCS Logistics Philippines to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta name="keywords" content="logistics, transportation, RCS Logistics, Philippines, forwarding, brokerage, sea land service, freight forwarding, international shipping, supply chain management, cargo handling, customs brokerage, project cargo, warehousing, import export, air freight, ocean freight, domestic transportation, logistics services" />
          <meta property="og:url" content="https://rcslogisticsph.com/contactUs" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="RCS Logistics Philippines - Moving You Forward" />
          <meta property="twitter:description" content="Partner with the best to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta property="twitter:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
        </Helmet>
      {/* Hero Section with Dynamic Background and smooth transition */}
      <section
        className="gallery-hero-section d-flex align-items-center"
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <button 
                disabled 
                className="gallery-hero-button mb-4"
              >
                GET IN TOUCH
              </button>
              <h1 className="text-white mb-4 gallery-hero-title">
                Contact Us
              </h1>
              <p className="text-white-50 fs-5 gallery-hero-subtitle">
                Feel free to reach out to us for all your logistics needs; we're here to assist you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Include the other sections*/}
      <ContactUs />
    </>
  );
};

export default HeroContactUs;
